import React from "react";
import EncodeDecodeView from "../../components/EncodeDecodeView.jsx";

const Index = ({ args }) => {
  return (
    <EncodeDecodeView
      onEncode={(text) =>
        args?.isEncode
          ? Buffer.from(text).toString("base64")
          : Buffer.from(text, "base64").toString("ascii")
      }
      swapUrl={window.location.href.replace(
        args?.isEncode ? "encoder" : "decoder",
        args?.isEncode ? "decoder" : "encoder"
      )}
    />
  );
};

export default Index;
